export * from './app-sidebar-header.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-sidebar-header/index.ts